import { invoke } from '@shared/easyfy.decorators';
import TranslatorService, { TranslationKeys } from '@clientWebServices/translator.service';
import { SnackBar, SnackbarSeverity } from '@clientWebModules/snackbar';
import { MESSAGE_KEYS } from '@clientShared/messageKeys';

@invoke
export default class MessageService {
  static Instance: MessageService;
  private translator: TranslatorService;
  constructor() {
    if (MessageService.Instance) return MessageService.Instance;
    MessageService.Instance = this;
    this.translator = TranslatorService.getInstance();
  }

  displayDefaultErrorMessage(): void {
    this.displayMessage(SnackbarSeverity.error, MESSAGE_KEYS.error);
  }

  displayErrorMessage(key: TranslationKeys): void {
    this.displayMessage(SnackbarSeverity.error, key);
  }

  displayDefaultSuccessMessage(): void {
    this.displayMessage(SnackbarSeverity.success, MESSAGE_KEYS.success);
  }

  displaySuccessMessage(key: TranslationKeys): void {
    this.displayMessage(SnackbarSeverity.success, key);
  }

  displayDefaultLoadingMessage(): void {
    this.displayMessage(SnackbarSeverity.warning, MESSAGE_KEYS.loading);
  }

  displayDefaultNoResultsMessage(): void {
    this.displayMessage(SnackbarSeverity.warning, MESSAGE_KEYS.noResults);
  }

  displayWarningMessage(key: TranslationKeys): void {
    this.displayMessage(SnackbarSeverity.warning, key);
  }

  private async displayMessage(severity: SnackbarSeverity, key: TranslationKeys): Promise<void> {
    const message = await this.translator.translate(key);
    if (message) {
      SnackBar.appendSnackbar(severity, message);
    } else {
      console.error(`Translation not found for key: ${message}`);
    }
  }
}
